import { Dropdown, FormController, FormLabel, MenuItem, Popover, TextField, Typography, Link, } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import React, { useState, useEffect, useRef, } from 'react';
import { getCitiesByZip } from '../../../utils/order-details/LineItemUtils';
import { EditDeliveryAddressErrorMessages, } from '../../../models/edit-delivery-address';
import '../../../styles/drawer.scss';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { addressRegex, nameRegex, zipRegex } from '../util/general';
export var EditDeliveryAddressChangeFormBody = function (_a) {
    var firstNameValue = _a.firstNameValue, lastNameValue = _a.lastNameValue, phoneNumberValue = _a.phoneNumberValue, streetAddressValue = _a.streetAddressValue, addressLineTwoValue = _a.addressLineTwoValue, zipCodeValue = _a.zipCodeValue, cityStateValue = _a.cityStateValue, invalidField = _a.invalidField, isExcludedAddress = _a.isExcludedAddress, isValidated = _a.isValidated, isPOBoxAddressLine1 = _a.isPOBoxAddressLine1, isPOBoxAddressLine2 = _a.isPOBoxAddressLine2, getCitiesByZipCode = _a.getCitiesByZipCode, setIsValidated = _a.setIsValidated, setIsPOBoxAddressLine1 = _a.setIsPOBoxAddressLine1, setIsPOBoxAddressLine2 = _a.setIsPOBoxAddressLine2, setFirstName = _a.setFirstName, setLastName = _a.setLastName, setStreetAddress = _a.setStreetAddress, setAddressLineTwo = _a.setAddressLineTwo, setZipCode = _a.setZipCode, setIsZipCodeChanged = _a.setIsZipCodeChanged, handleZipCodeValueChange = _a.handleZipCodeValueChange, handleChange = _a.handleChange, isSameAddress = _a.isSameAddress, setIsSameAddress = _a.setIsSameAddress, setCityState = _a.setCityState, handleClearAll = _a.handleClearAll;
    // RegEx duplicated from Checkout as of 9/14/25: ocm_pd_component_cart-input-form/src/util/validation-patterns.js
    var poBoxRegEx = /(POST?\s*OF(F)?(FICE)?\s*B(OX))|(POST(ED)?\s*B(O?X))|[P][\s.]*([O,B]X?)*[\s.]*[B][O]?[X]|(POB )|^BOX [0-9]+$/i;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState([]), localCities = _c[0], setLocalCities = _c[1];
    var hasEffectRun = useRef(false);
    useEffect(function () {
        if (!hasEffectRun.current && zipCodeValue.length === 5) {
            var cities = getCitiesByZip(zipCodeValue);
            setLocalCities(cities);
            hasEffectRun.current = true;
        }
    }, [zipCodeValue]);
    var handleStreetAddressStatus = function () {
        if ((invalidField && streetAddressValue === '') ||
            isExcludedAddress ||
            isPOBoxAddressLine1 ||
            isSameAddress) {
            return 'error';
        }
        if (!isValidated) {
            return 'warning';
        }
        return undefined;
    };
    var handleStreetAddressStatusMessage = function () {
        if (isPOBoxAddressLine1) {
            return 'Orders cannot be shipped to a P.O.Box.';
        }
        if (handleStreetAddressStatus() === 'warning') {
            return 'Please verify your delivery address is correct before continuing.';
        }
        if (isExcludedAddress || isSameAddress) {
            return 'Please update your delivery address to continue.';
        }
        if (invalidField && streetAddressValue === '') {
            return 'Please enter your delivery address.';
        }
        return undefined;
    };
    var handleAddressLine2Status = function () {
        if ((addressLineTwoValue && isExcludedAddress) ||
            isPOBoxAddressLine2 ||
            isSameAddress) {
            return 'error';
        }
        if (addressLineTwoValue && !isValidated) {
            return 'warning';
        }
        return undefined;
    };
    var handleAddressLine2StatusMessage = function () {
        if (isPOBoxAddressLine2) {
            return 'Orders cannot be shipped to a P.O.Box.';
        }
        return undefined;
    };
    var handleZipCodeStatus = function () {
        if ((invalidField && zipCodeValue.length !== 5) || isExcludedAddress) {
            return 'error';
        }
        if (!isValidated) {
            return 'warning';
        }
        if (isSameAddress) {
            return 'error';
        }
        return undefined;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-text-right sui-pr-5 sui-pt-4" },
            React.createElement(Link, { component: "button", onClick: function () { return handleClearAll(); } }, "Clear All")),
        React.createElement("div", { className: "sui-pb-6" },
            React.createElement(TextField, { id: "firstName", label: "First Name *", placeholder: "First Name", value: firstNameValue, inputProps: { maxLength: 40 }, onChange: function (event) {
                    if (nameRegex.test(event.target.value) ||
                        event.target.value === '') {
                        setIsSameAddress(false);
                        setFirstName(event.target.value);
                    }
                }, fullWidth: true, status: (invalidField && firstNameValue === '') || isSameAddress
                    ? 'error'
                    : undefined, statusMessage: invalidField && firstNameValue === ''
                    ? 'Please enter your first name.'
                    : undefined })),
        React.createElement("div", { className: "sui-pb-6" },
            React.createElement(TextField, { id: "lastName", label: "Last Name *", placeholder: "Last Name", value: lastNameValue, inputProps: { maxLength: 60 }, onChange: function (event) {
                    if (nameRegex.test(event.target.value) ||
                        event.target.value === '') {
                        setIsSameAddress(false);
                        setLastName(event.target.value);
                    }
                }, fullWidth: true, status: (invalidField && lastNameValue === '') || isSameAddress
                    ? 'error'
                    : undefined, statusMessage: invalidField && lastNameValue === ''
                    ? 'Please enter your last name.'
                    : undefined })),
        React.createElement("div", { className: "sui-pb-6" },
            React.createElement("div", { className: "sui-flex" },
                React.createElement(FormLabel, { htmlFor: "phoneNumber" }, "Phone Number"),
                React.createElement("div", { className: "sui-ml-2 sui-self-center" },
                    React.createElement(InfoFilled, { style: { cursor: 'pointer' }, size: "small", color: "info", onClick: function (event) {
                            setAnchorEl(event.currentTarget);
                        } }),
                    React.createElement(Popover, { id: anchorEl ? 'simple-popover' : undefined, open: anchorEl, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, placement: "right" },
                        React.createElement("div", { className: "sui-w-[252px]" },
                            React.createElement(Typography, { variant: "body-base" }, "If you previously opted in to receive order status updates, you'll continue to receive updates at this number."))))),
            React.createElement(Typography, { weight: "bold" }, phoneNumberValue)),
        React.createElement("div", { className: "sui-pb-6" },
            React.createElement(TextField, { id: "streetAddress", label: "Delivery Address *", placeholder: "Street Address", value: streetAddressValue, inputProps: { maxLength: 30 }, onChange: function (event) {
                    if (addressRegex.test(event.target.value) ||
                        event.target.value === '') {
                        setIsValidated(true);
                        setIsSameAddress(false);
                        if (poBoxRegEx.test(event.target.value)) {
                            setIsPOBoxAddressLine1(true);
                        }
                        else {
                            setIsPOBoxAddressLine1(false);
                        }
                        setStreetAddress(event.target.value);
                    }
                }, fullWidth: true, status: handleStreetAddressStatus(), statusMessage: handleStreetAddressStatusMessage() })),
        React.createElement("div", { className: "sui-pb-6" },
            React.createElement(TextField, { id: "addressLine2", label: "Address Line 2", placeholder: "Apartment, suite, building, etc.", optional: true, value: addressLineTwoValue || '', inputProps: { maxLength: 30, required: false }, onChange: function (event) {
                    if (addressRegex.test(event.target.value) ||
                        event.target.value === '') {
                        // addressLineTwo set to null if empty for OMM API expectations if no actual value is present
                        setIsValidated(true);
                        setIsSameAddress(false);
                        if (poBoxRegEx.test(event.target.value)) {
                            setIsPOBoxAddressLine2(true);
                        }
                        else {
                            setIsPOBoxAddressLine2(false);
                        }
                        setAddressLineTwo(event.target.value || null);
                    }
                }, fullWidth: true, status: handleAddressLine2Status(), statusMessage: handleAddressLine2StatusMessage() })),
        React.createElement("div", { className: "sui-pb-6 sui-flex sui-justify-between" },
            React.createElement("div", { className: "sui-w-4/12 sm:sui-w-3/12 sui-pr-6" },
                React.createElement(TextField, { id: "zipCode", label: "ZIP Code *", placeholder: "Zip Code", value: zipCodeValue, inputProps: { maxLength: 5 }, onChange: function (event) {
                        setCityState('');
                        setLocalCities([]);
                        if (zipRegex.test(event.target.value) ||
                            event.target.value === '') {
                            setZipCode(event.target.value);
                            setIsValidated(true);
                            setIsSameAddress(false);
                        }
                        if (event.target.value.length === 5) {
                            setIsZipCodeChanged(true);
                            handleZipCodeValueChange(event.target.value);
                        }
                    }, fullWidth: true, status: handleZipCodeStatus(), statusMessage: invalidField && zipCodeValue.length !== 5
                        ? 'Please enter your 5-digit ZIP code.'
                        : null, helpMessage: "Enter ZIP Code to see City and State" })),
            React.createElement("div", { className: "sui-w-8/12 sm:sui-w-9/12" }, zipCodeValue.length === 5 &&
                (getCitiesByZipCode.length > 0 ||
                    !cityStateValue.includes('undefined')) && (React.createElement(React.Fragment, null,
                ((getCitiesByZipCode === null || getCitiesByZipCode === void 0 ? void 0 : getCitiesByZipCode.length) === 1 ||
                    (localCities === null || localCities === void 0 ? void 0 : localCities.length) === 1) && (React.createElement("div", null,
                    React.createElement(Typography, null, "City, State"),
                    React.createElement(Typography, { weight: "bold", style: { height: '44px', alignContent: 'center' } }, cityStateValue))),
                ((getCitiesByZipCode === null || getCitiesByZipCode === void 0 ? void 0 : getCitiesByZipCode.length) > 1 || localCities.length > 1) &&
                    !cityStateValue.includes('undefined') && (React.createElement(FormController, { fullWidth: true },
                    React.createElement(FormLabel, null, "City, State"),
                    React.createElement(Dropdown, { value: cityStateValue, defaultValue: cityStateValue, placeholder: "", onChange: function (event) {
                            setIsSameAddress(false);
                            handleChange(event);
                        }, MenuProps: { placement: 'top' } }, getCitiesByZipCode === null || getCitiesByZipCode === void 0 ? void 0 :
                        getCitiesByZipCode.map(function (city) { return (React.createElement(MenuItem, { key: city, value: "".concat(city === null || city === void 0 ? void 0 : city.city, ", ").concat(city === null || city === void 0 ? void 0 : city.stateCode) }, "".concat(city === null || city === void 0 ? void 0 : city.city, ", ").concat(city === null || city === void 0 ? void 0 : city.stateCode))); }),
                        (getCitiesByZipCode === null || getCitiesByZipCode === void 0 ? void 0 : getCitiesByZipCode.length) <= 1
                            ? localCities === null || localCities === void 0 ? void 0 : localCities.map(function (city) { return (React.createElement(MenuItem, { key: city, value: "".concat(city === null || city === void 0 ? void 0 : city.city, ", ").concat(city === null || city === void 0 ? void 0 : city.stateCode) }, "".concat(city === null || city === void 0 ? void 0 : city.city, ", ").concat(city === null || city === void 0 ? void 0 : city.stateCode))); })
                            : null))))))),
        isValidated === false ? (React.createElement(AlertBanner, { status: "warning" }, EditDeliveryAddressErrorMessages.UNRECOGNIZED_ADDRESS)) : null,
        isExcludedAddress && (React.createElement(AlertBanner, { status: "error" }, EditDeliveryAddressErrorMessages.EXCLUDED_ADDRESS)),
        isSameAddress && (React.createElement(AlertBanner, { status: "error" },
            React.createElement(Typography, null, EditDeliveryAddressErrorMessages.SAME_ADDRESS)))));
};
